(function() {
  'use strict';

  var config = window.cartDrawerConfig || {};
  var wrapper = null;
  var isOpen = false;
  var previouslyFocused = null;
  var loadToken = 0;
  var activeCurrency = config.currencyCode || '';
  var upgradeBusy = false;
  var recommendationToken = 0;
  var recommendationNotice = '';
  var homepageCartImages = {};


  function getWrapper() {
    if (!wrapper || !wrapper.isConnected) {
      wrapper = document.querySelector('[data-cart-drawer]');
    }
    return wrapper;
  }

  function init() {
    if (document.querySelector('[data-jc-cart-page]')) return;
    getWrapper();
    initProductCardForms();

    if (!wrapper) return;

    bindEvents();
    interceptCartLinks();

    if (new URLSearchParams(window.location.search).get('open_cart') === '1') {
      open();
      var url = new URL(window.location.href);
      url.searchParams.delete('open_cart');
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  }

  function initProductCardForms() {
    document.addEventListener('submit', handleProductCardFormSubmit, true);
  }

  function handleProductCardFormSubmit(evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM' || !form.classList.contains('add-to-cart')) return;
    if (form.closest('[data-product-form]')) return;

    evt.preventDefault();
    evt.stopPropagation();
    if (upgradeBusy) return;

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-adding-to-cart');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function(res) { return res.json(); })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          throw new Error(json.description || 'Could not add to cart');
        }
        return open();
      })
      .catch(function(err) {
        alert(err.message || 'An error occurred');
      })
      .finally(function() {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-adding-to-cart');
        }
      });
  }

  function bindEvents() {
    wrapper.querySelectorAll('[data-cart-drawer-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });

    wrapper.addEventListener('click', function(evt) {
      if (evt.target === wrapper.querySelector('.cart-drawer__backdrop')) {
        close();
      }
    });

    document.addEventListener('keydown', function(evt) {
      if (evt.key === 'Escape' && isOpen) close();
    });

    wrapper.addEventListener('click', function(evt) {
      if (upgradeBusy) { evt.preventDefault(); evt.stopPropagation(); return; }
      var upgradeBtn = evt.target.closest('[data-cart-drawer-upgrade]');
      if (upgradeBtn) { evt.preventDefault(); upgradeRecommendation(upgradeBtn); return; }
      var addBtn = evt.target.closest('[data-cart-drawer-add]');
      if (addBtn) {
        evt.preventDefault();
        addRecommendation(addBtn);
        return;
      }

      var removeBtn = evt.target.closest('[data-cart-drawer-remove]');
      if (removeBtn) {
        evt.preventDefault();
        changeLine(removeBtn.dataset.line, 0);
        return;
      }

      var qtyBtn = evt.target.closest('[data-cart-drawer-qty]');
      if (qtyBtn) {
        evt.preventDefault();
        var line = qtyBtn.dataset.line;
        var qty = parseInt(qtyBtn.dataset.qty, 10);
        if (qty >= 0) changeLine(line, qty);
        return;
      }

      var discountRemoveBtn = evt.target.closest('[data-cart-drawer-discount-remove]');
      if (discountRemoveBtn) {
        evt.preventDefault();
        removeDiscount();
      }
    });

    var discountForm = wrapper.querySelector('[data-cart-drawer-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function(evt) {
        evt.preventDefault();
        if (upgradeBusy) return;
        var input = discountForm.querySelector('[data-cart-drawer-discount-input]');
        applyDiscount(input ? input.value.trim() : '');
      });
    }

    var retryBtn = wrapper.querySelector('[data-cart-drawer-retry]');
    if (retryBtn) {
      retryBtn.addEventListener('click', function() {
        var token = ++loadToken;
        setLoading(true);
        refresh()
          .catch(function(err) {
            if (token === loadToken) showLoadError();
            console.error('Cart drawer refresh failed:', err);
          })
          .finally(function() {
            if (token === loadToken) setLoading(false);
          });
      });
    }

    var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
    openTriggers.forEach(function(el) {
      el.addEventListener('click', function(evt) {
        evt.preventDefault();
        open();
      });
    });
  }

  function interceptCartLinks() {
    document.addEventListener('click', function(evt) {
      var link = evt.target.closest('a[href]');
      if (!link || link.hasAttribute('data-cart-drawer-bypass')) return;
      if (link.hasAttribute('data-cart-drawer-open')) return;

      var href = link.getAttribute('href');
      if (!href) return;

      var cartPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
      cartPath = cartPath.replace(/\/$/, '');

      var normalized = href.split('?')[0].split('#')[0];
      if (normalized === '/cart' || normalized === cartPath || normalized.endsWith('/cart')) {
        if (href.indexOf('/cart/add') === -1 && href.indexOf('/cart/change') === -1 && href.indexOf('/cart/update') === -1) {
          evt.preventDefault();
          open();
        }
      }
    });
  }

  function showDrawer() {
    wrapper.classList.remove('cart-drawer-wrapper--hidden');
    document.documentElement.classList.add('cart-drawer-open');
    isOpen = true;
    var panel = wrapper.querySelector('.cart-drawer');
    if (panel) panel.focus();
  }

  function setLoading(loading) {
    wrapper.classList.toggle('cart-drawer-wrapper--loading', loading);
    if (loading) wrapper.classList.remove('cart-drawer-wrapper--load-error');

    var body = wrapper.querySelector('[data-cart-drawer-body]');
    if (body) body.setAttribute('aria-busy', loading ? 'true' : 'false');

    var loadingEl = wrapper.querySelector('[data-cart-drawer-loading]');
    if (loadingEl) loadingEl.setAttribute('aria-hidden', loading ? 'false' : 'true');
  }

  function showLoadError() {
    wrapper.classList.add('cart-drawer-wrapper--load-error');
  }

  function cartPageFallback() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.assign(root.replace(/\/?$/, '/') + 'cart');
    return Promise.resolve();
  }

  function open() {
    if (document.querySelector('[data-jc-cart-page]') || !getWrapper() || !wrapper.querySelector('[data-cart-drawer-items]')) return cartPageFallback();
    previouslyFocused = document.activeElement;
    var token = ++loadToken;
    var fallbackTimer = setTimeout(function() {
      if (token === loadToken && isOpen) cartPageFallback();
    }, 8000);
    try {
      showDrawer();
      setLoading(true);
      return refresh('cart-drawer')
        .catch(function(err) {
          console.error('Cart drawer refresh failed:', err);
          if (token === loadToken && isOpen) cartPageFallback();
        })
        .finally(function() {
          clearTimeout(fallbackTimer);
          if (token === loadToken && wrapper && wrapper.isConnected) setLoading(false);
        });
    } catch (err) {
      clearTimeout(fallbackTimer);
      return cartPageFallback();
    }
  }

  function close() {
    if (!getWrapper()) return;
    wrapper.classList.add('cart-drawer-wrapper--hidden');
    document.documentElement.classList.remove('cart-drawer-open');
    isOpen = false;
    if (previouslyFocused) previouslyFocused.focus();
  }

  function notifyCartChanged(cart, source) {
    if (window.theme && typeof window.theme.publishCartChanged === 'function') {
      window.theme.publishCartChanged(cart, source);
    }
  }

  function completeCartUpdate(cart, source) {
    render(cart);
    updateCartCounts(cart.item_count);
    if (source) notifyCartChanged(cart, source);
    return cart;
  }

  function refresh(source) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .then(function(cart) {
        return completeCartUpdate(cart, source);
      });
  }

  function render(cart) {
    if (cart && cart.currency) activeCurrency = cart.currency;
    renderHeading(cart);
    renderItems(cart);
    renderEmpty(cart);
    renderSubtotal(cart);
    renderPreorderNotice(cart);
    renderAfterpay(cart);
    renderDiscounts(cart);
    updateSpendEncourager(cart);
    loadRecommendations(cart);
  }

  function renderHeading(cart) {
    var el = wrapper.querySelector('[data-cart-drawer-count]');
    if (el) el.textContent = cart.item_count;
  }

  function renderLinePrice(item) {
    if (item.original_line_price > item.final_line_price) {
      return '<span class="cart-drawer__item-price cart-drawer__item-price--discounted">'
        + '<s class="cart-drawer__item-price-original">' + formatMoney(item.original_line_price) + '</s>'
        + '<span class="cart-drawer__item-price-final">' + formatMoney(item.final_line_price) + '</span>'
        + '</span>';
    }
    return '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';
  }

  function renderItems(cart) {
    var container = wrapper.querySelector('[data-cart-drawer-items]');
    if (!container) return;

    if (!cart.items.length) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = cart.items.map(function(item, index) {
      var line = index + 1;
      var homepageCard = Array.from(document.querySelectorAll('.featured-collection-side-scrolling .product-card')).find(function(card) {
        var link = card.querySelector('a');
        return link && link.getAttribute('href').split('?')[0] === '/products/' + item.handle;
      });
      var homepageImage = homepageCard && homepageCard.querySelector('.maggie-collection-art img, .grid-view-item__image--primary');
      var imageUrl = homepageCartImages[item.variant_id] || (homepageImage && (homepageImage.currentSrc || homepageImage.src)) || item.image;
      var img = imageUrl
        ? '<img src="' + escapeHtml(imageUrl) + '" data-cart-image-variant="' + item.variant_id + '" alt="' + escapeHtml(item.product_title) + '" class="cart-drawer__item-image">'
        : '';
      var price = renderLinePrice(item);
      var isPreorder = Number(item.product_id) === 10549091107000 || Number(item.product_id) === 10548517175480;

      return '<div class="cart-drawer__item" data-line="' + line + '">'
        + '<a href="' + item.url + '" class="cart-drawer__item-image-link">' + img + '</a>'
        + '<div class="cart-drawer__item-details">'
        + '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
        + (isPreorder ? '<div class="cart-drawer__preorder" style="font-size:12px;line-height:1.4;color:#6b2738;margin:5px 0 9px;">Pre-order · Ships from Friday 23 October 2026</div>' : '')
        + '<div class="cart-drawer__item-actions">'
        + '<fieldset class="product-form__quantity-group cart-drawer__qty" data-cart-drawer-qty-group data-line="' + line + '">'
        + '<span class="cart-drawer__qty-loading" aria-hidden="true"></span>'
        + '<button type="button" class="sub" data-cart-drawer-qty data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">-</button>'
        + '<input type="number" value="' + item.quantity + '" min="0" readonly aria-label="Quantity">'
        + '<button type="button" class="add" data-cart-drawer-qty data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>'
        + '</fieldset>'
        + '<span class="cart-drawer__item-price">' + price + '</span>'
        + '</div>'
        + '</div>'
        + '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove data-line="' + line + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">'
        + '&times;'
        + '</button>'
        + '</div>';
    }).join('');
  }

  function renderEmpty(cart) {
    var empty = wrapper.querySelector('[data-cart-drawer-empty]');
    var body = wrapper.querySelector('[data-cart-drawer-body]');
    var upsells = wrapper.querySelector('[data-cart-drawer-upsells]');
    var footer = wrapper.querySelector('[data-cart-drawer-footer]');

    if (empty) empty.style.display = cart.item_count ? 'none' : '';
    if (body) body.classList.toggle('cart-drawer__body--empty', !cart.item_count);
    if (upsells) upsells.style.display = cart.item_count ? '' : 'none';
    if (footer) footer.style.display = cart.item_count ? '' : 'none';
  }

  function renderSubtotal(cart) {
    var el = wrapper.querySelector('[data-cart-drawer-subtotal]');
    if (el) {
      if (cart.original_total_price && cart.original_total_price > cart.total_price) {
        el.innerHTML = '<span class="cart-drawer__subtotal-original">' + formatMoney(cart.original_total_price) + '</span>'
          + '<span class="cart-drawer__subtotal-final">' + formatMoney(cart.total_price) + '</span>';
      } else {
        el.textContent = formatMoney(cart.total_price);
      }
    }

    var label = wrapper.querySelector('[data-cart-drawer-subtotal-label]');
    if (label) {
      label.textContent = cart.item_count === 1
        ? 'Subtotal (1 item)'
        : 'Subtotal (' + cart.item_count + ' items)';
    }
  }

  function renderPreorderNotice(cart) {
    var notice = wrapper.querySelector('[data-cart-drawer-preorder-notice]');
    if (!notice) return;
    notice.hidden = !(cart.items || []).some(function(item) {
      return Number(item.product_id) === 10549091107000 || Number(item.product_id) === 10548517175480;
    });
  }

  function renderAfterpay(cart) {
    var el = wrapper.querySelector('[data-cart-drawer-afterpay]');
    if (!el) return;
    if (cart.total_price <= 0) {
      el.textContent = '';
      return;
    }
    el.innerHTML = 'or 4 interest-free payments of <strong>' + formatMoney(Math.round(cart.total_price / 4)) + '</strong> with Afterpay';
  }

  function getActiveDiscounts(cart) {
    var amountsByTitle = {};
    var sourceByTitle = {};

    function setCartDiscount(application, amount) {
      if (!application || !application.title || application.type === 'automatic') return;
      amountsByTitle[application.title] = amount || 0;
      sourceByTitle[application.title] = 'cart';
    }

    function addLineDiscount(application, amount) {
      if (!application || !application.title || application.type === 'automatic') return;
      if (sourceByTitle[application.title] === 'cart') return;
      if (!amountsByTitle[application.title]) amountsByTitle[application.title] = 0;
      amountsByTitle[application.title] += amount || 0;
      sourceByTitle[application.title] = 'line';
    }

    (cart.cart_level_discount_applications || []).forEach(function(d) {
      setCartDiscount(d, d.total_allocated_amount);
    });

    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        addLineDiscount(allocation.discount_application, allocation.amount);
      });
    });

    return Object.keys(amountsByTitle).map(function(title) {
      return {
        title: title,
        amount: amountsByTitle[title]
      };
    });
  }

  function updateDiscountFormVisibility(hasDiscounts) {
    var form = wrapper.querySelector('[data-cart-drawer-discount-form]');
    if (form) form.style.display = hasDiscounts ? 'none' : '';
  }

  function renderDiscounts(cart) {
    var container = wrapper.querySelector('[data-cart-drawer-discounts]');
    if (!container) return;

    var discounts = getActiveDiscounts(cart);
    updateDiscountFormVisibility(discounts.length > 0);

    if (discounts.length) {
      var errorEl = wrapper.querySelector('[data-cart-drawer-discount-error]');
      if (errorEl) errorEl.textContent = '';
    }

    if (!discounts.length) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = discounts.map(function(d) {
      return '<div class="cart-drawer__discount-applied">'
        + '<span class="cart-drawer__discount-applied-label">' + escapeHtml(d.title) + ' (-' + formatMoney(d.amount) + ')</span>'
        + '<button type="button" class="cart-drawer__discount-remove" data-cart-drawer-discount-remove aria-label="Remove ' + escapeHtml(d.title) + '">&times;</button>'
        + '</div>';
    }).join('');
  }

  function updateSpendEncourager(cart) {
    var encourager = wrapper.querySelector('[data-cart-drawer-encourager]');
    if (!encourager) return;

    var tiers = config.spendTiers || [];
    if (!tiers.length) {
      encourager.style.display = 'none';
      return;
    }

    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var subtotal = cart.total_price / 100;
    var scaledTiers = tiers.map(function(t) {
      return { threshold: parseFloat(t.threshold) * rate, label: t.label };
    }).sort(function(a, b) { return a.threshold - b.threshold; });

    var achieved = -1;
    for (var i = scaledTiers.length - 1; i >= 0; i--) {
      if (subtotal >= scaledTiers[i].threshold) {
        achieved = i;
        break;
      }
    }

    var next = achieved < scaledTiers.length - 1 ? achieved + 1 : null;
    var messageEl = encourager.querySelector('[data-cart-drawer-encourager-message]');
    var progressEl = encourager.querySelector('[data-cart-drawer-encourager-progress]');

    var message = '';
    var percent = 0;

    if (next === null) {
      message = 'You have unlocked FREE ' + scaledTiers[achieved].label + '!';
      percent = 100;
    } else {
      var nextTier = scaledTiers[next];
      var remaining = nextTier.threshold - subtotal;
      message = 'You are ' + (config.currencySymbol || '$') + formatAmount(remaining) + ' away from FREE ' + nextTier.label + '!';
      percent = nextTier.threshold > 0
        ? Math.min(100, Math.max(0, (subtotal / nextTier.threshold) * 100))
        : 100;
    }

    if (messageEl) messageEl.textContent = message;
    if (progressEl) progressEl.style.width = percent + '%';

    encourager.style.display = '';
  }

  function buildRecommendationsUrl(sectionId, productId, limit, intent) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var baseUrl = config.recommendationsUrl || root.replace(/\/?$/, '/') + 'recommendations/products';
    baseUrl = baseUrl.replace(/\.json\/?$/, '');
    if (baseUrl.charAt(0) === '/' && root !== '/') {
      baseUrl = root.replace(/\/$/, '') + baseUrl;
    }
    return baseUrl
      + '?section_id=' + encodeURIComponent(sectionId)
      + '&product_id=' + productId
      + '&limit=' + limit
      + '&intent=' + (intent || 'related');
  }

  function loadRecommendations(cart) {
    var token = ++recommendationToken;
    var container = wrapper.querySelector('[data-cart-drawer-recommendations]');
    if (!container || !cart.items.length) {
      if (container) container.innerHTML = '';
      return;
    }

    var productId = cart.items[cart.items.length - 1].product_id;
    var limit = config.upsellLimit || 3;
    var fetchLimit = Math.min(10, limit + cart.items.length);
    var sectionId = config.upsellSectionId || 'cart-drawer-upsells';
    var url = buildRecommendationsUrl(sectionId, productId, fetchLimit, 'related');

    fetch(url, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('Recommendations request failed: ' + res.status);
        return res.text();
      })
      .then(function(html) {
        if (token !== recommendationToken) return;
        if (!html.trim()) {
          container.innerHTML = '';
          return;
        }

        var doc = document.createElement('div');
        doc.innerHTML = html;
        var imageData = doc.querySelector('[data-cart-homepage-images]');
        if (imageData) {
          imageData.content.querySelectorAll('[data-variant-id]').forEach(function(record) {
            if (!record.dataset.imageUrl) return;
            homepageCartImages[record.dataset.variantId] = record.dataset.imageUrl;
            wrapper.querySelectorAll('[data-cart-image-variant="' + record.dataset.variantId + '"]').forEach(function(img) {
              img.src = record.dataset.imageUrl;
            });
          });
        }
        var content = doc.querySelector('[data-cart-drawer-upsells-content]');
        if (!content) {
          container.innerHTML = '';
          return;
        }

        container.innerHTML = content.innerHTML;

        var cards = container.querySelectorAll('.cart-drawer__upsell-card');
        for (var i = limit; i < cards.length; i++) {
          cards[i].remove();
        }

        if (!container.querySelector('.cart-drawer__upsell-card')) {
          container.innerHTML = '';
        }
        showRecommendationNotice(container);
        var upsells = wrapper.querySelector('[data-cart-drawer-upsells]');
        if (upsells) upsells.style.display = container.children.length ? '' : 'none';
      })
      .catch(function(err) {
        if (token !== recommendationToken) return;
        console.error('Cart drawer recommendations failed:', err);
        container.innerHTML = '';
        showRecommendationNotice(container);
      });
  }

  function setQtyGroupLoading(line, loading) {
    var group = wrapper.querySelector('[data-cart-drawer-qty-group][data-line="' + line + '"]');
    if (group) group.classList.toggle('cart-drawer__qty--loading', loading);
  }

  function changeLine(line, quantity) {
    if (upgradeBusy) return;
    recommendationNotice = '';
    setQtyGroupLoading(line, true);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        return completeCartUpdate(cart, 'cart-drawer');
      })
      .catch(function(err) {
        setQtyGroupLoading(line, false);
        console.error('Cart line update failed:', err);
      });
  }

  function addRecommendation(btn) {
    if (upgradeBusy) return;
    recommendationNotice = '';
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('cart-drawer__upsell-add--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(res) { return res.json().then(function(json) {
        if (!res.ok || (json.status && json.status >= 400)) throw new Error(json.description || 'Could not add to cart');
        return json;
      }); })
      .then(function() { return refresh('cart-drawer'); })
      .catch(function(err) {
        recommendationNotice = err.message;
        return refresh('cart-drawer');
      })
      .finally(function() {
        btn.classList.remove('cart-drawer__upsell-add--loading');
        btn.disabled = false;
      });
  }

  function cartRequest(path, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function(res) {
      return res.json().then(function(json) {
        if (!res.ok || (json.status && json.status >= 400)) throw new Error(json.description || 'Cart request failed');
        return json;
      });
    });
  }

  function eligibleUpgrade(cart, data, product) {
    var source = cart.items && cart.items[0];
    var variant = product.variants && product.variants.find(function(v) { return String(v.id) === data.variantId; });
    return !!(source && cart.items.length === 1 && source.quantity === 1 && !source.selling_plan_allocation
      && source.key === data.sourceKey
      && (source.handle === 'glass-skin-collagen-night-mask' || source.handle === 'lift-and-firm-eyemask')
      && source.original_price === Number(data.sourcePrice)
      && cart.currency === data.currency
      && variant && variant.available && variant.price === Number(data.bundlePrice)
      && variant.price >= source.original_price);
  }

  async function upgradeRecommendation(btn) {
    if (upgradeBusy) return;
    upgradeBusy = true;
    recommendationNotice = '';
    setLoading(true);
    btn.disabled = true;
    var data = Object.assign({}, btn.dataset);
    var sourceVariant = null;
    var attemptedAdd = false;
    try {
      var before = await cartRequest('cart.js');
      var product = await cartRequest('products/glass-skin-collection.js');
      if (!eligibleUpgrade(before, data, product)) {
        recommendationNotice = data.changed;
        completeCartUpdate(before, 'cart-drawer');
        return;
      }
      sourceVariant = before.items[0].variant_id;
      attemptedAdd = true;
      await cartRequest('cart/add.js', { id: Number(data.variantId), quantity: 1 });
      var addedCart = await cartRequest('cart.js');
      var source = addedCart.items.find(function(item) { return item.variant_id === sourceVariant; });
      var bundle = addedCart.items.find(function(item) { return String(item.variant_id) === data.variantId; });
      if (!source || source.quantity !== 1 || !bundle || bundle.quantity !== 1 || addedCart.items.length !== 2) {
        throw new Error('Cart changed during upgrade');
      }
      var finished = await cartRequest('cart/change.js', { id: source.key, quantity: 0 });
      if (finished.items.some(function(item) { return item.variant_id === sourceVariant; })) throw new Error('Original item remains');
      completeCartUpdate(finished, 'cart-drawer');
    } catch (err) {
      recommendationNotice = data.error;
      try {
        var current = await cartRequest('cart.js');
        if (attemptedAdd) {
          var original = current.items.find(function(item) { return item.variant_id === sourceVariant; });
          var added = current.items.find(function(item) { return String(item.variant_id) === data.variantId; });
          if (original && added) {
            current = await cartRequest('cart/change.js', { id: added.key, quantity: Math.max(0, added.quantity - 1) });
          } else if (!original && added) {
            recommendationNotice = '';
          }
        }
        completeCartUpdate(current, 'cart-drawer');
      } catch (recoveryError) {
        showLoadError();
        var error = wrapper.querySelector('[data-cart-drawer-load-error]');
        if (error) error.textContent = data.error;
        cartPageFallback();
      }
    } finally {
      upgradeBusy = false;
      setLoading(false);
      btn.disabled = false;
    }
  }

  function showRecommendationNotice(container) {
    if (!recommendationNotice) return;
    var notice = document.createElement('p');
    notice.setAttribute('role', 'alert');
    notice.className = 'cart-drawer__upgrade-note';
    notice.textContent = recommendationNotice;
    container.prepend(notice);
  }


  function clearDiscountFeedback() {
    var errorEl = wrapper.querySelector('[data-cart-drawer-discount-error]');
    if (errorEl) errorEl.textContent = '';
  }

  function setDiscountLoading(loading) {
    setDiscountSubmitLoading(loading);
    wrapper.classList.toggle('cart-drawer__discounts--loading', loading);
  }

  function removeDiscount() {
    var input = wrapper.querySelector('[data-cart-drawer-discount-input]');
    return applyDiscount('').then(function() {
      if (input) input.value = '';
    });
  }

  function setDiscountSubmitLoading(loading) {
    var btn = wrapper.querySelector('[data-cart-drawer-discount-submit]');
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('cart-drawer__discount-submit--loading', loading);
  }

  function getDiscountTitles(cart) {
    var titles = [];

    (cart.cart_level_discount_applications || []).forEach(function(d) {
      if (d.title) titles.push(d.title.toLowerCase());
    });

    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        var application = allocation.discount_application;
        if (application && application.title) titles.push(application.title.toLowerCase());
      });
    });

    return titles;
  }

  function discountWasApplied(cart, code, prior) {
    if (!code) return false;

    var codeLower = code.toLowerCase();
    var titles = getDiscountTitles(cart);
    var i;

    for (i = 0; i < titles.length; i++) {
      if (titles[i] === codeLower) return true;
    }

    if (prior) {
      if (cart.total_price < prior.totalPrice) return true;
      if ((cart.total_discount || 0) > prior.totalDiscount) return true;

      for (i = 0; i < titles.length; i++) {
        if (prior.discountTitles.indexOf(titles[i]) === -1) return true;
      }
    }

    for (i = 0; i < (cart.items || []).length; i++) {
      if (cart.items[i].original_line_price > cart.items[i].final_line_price) return true;
    }

    if (cart.original_total_price && cart.original_total_price > cart.total_price) return true;

    return false;
  }

  function applyDiscount(code) {
    var errorEl = wrapper.querySelector('[data-cart-drawer-discount-error]');
    clearDiscountFeedback();
    setDiscountLoading(true);

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(res) { return res.json(); })
      .then(function(beforeCart) {
        var prior = {
          totalPrice: beforeCart.total_price,
          totalDiscount: beforeCart.total_discount || 0,
          discountTitles: getDiscountTitles(beforeCart)
        };

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: code })
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Discount update failed');
            return res.json();
          })
          .then(function(cart) {
            var isCoffee = code && code.trim().toUpperCase() === 'COFFEE';
            var giftSync = isCoffee && window.theme &&
              typeof window.theme.syncFreeGifts === 'function'
              ? window.theme.syncFreeGifts(cart) : Promise.resolve(cart);

            return giftSync.then(function(finalCart) {
              completeCartUpdate(finalCart, isCoffee ? 'free-gift' : 'cart-drawer');

              if (code && !discountWasApplied(finalCart, code, prior)) {
                if (errorEl) errorEl.textContent = 'Discount code could not be applied. Please check the code and try again.';
              }

              return finalCart;
            });
          });
      })
      .catch(function() {
        if (errorEl) {
          errorEl.textContent = code
            ? 'Discount code could not be applied. Please try again.'
            : 'Discount could not be removed. Please try again.';
        }
      })
      .finally(function() {
        setDiscountLoading(false);
      });
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
    var bubble = document.querySelector('[data-cart-count-bubble]');
    if (bubble) bubble.classList.toggle('hide', count === 0);
  }

  function getMoneyFormat() {
    return config.moneyFormatWithCurrency
      || (window.theme && window.theme.moneyFormatWithCurrency)
      || config.moneyFormat
      || (window.theme && window.theme.moneyFormat)
      || '${{amount}}';
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    var formatted = '';

    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      try {
        formatted = window.theme.Currency.formatMoney(cents, format);
      } catch (err) {
        formatted = '';
      }
    }

    if (!formatted) {
      formatted = (config.currencySymbol || '$') + (cents / 100).toFixed(2);
    }

    if (activeCurrency && formatted.indexOf(activeCurrency) === -1) {
      formatted += ' ' + activeCurrency;
    }

    return formatted;
  }

  function formatAmount(dollars) {
    return dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.theme = window.theme || {};
  window.theme.CartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
